import { render } from "./NavTab.vue?vue&type=template&id=36bfdd1c&scoped=true&lang=html&bindings={\"text\":\"props\",\"img\":\"props\",\"uri\":\"props\"}"
import script from "./NavTab.vue?vue&type=script&lang=ts"
export * from "./NavTab.vue?vue&type=script&lang=ts"

import "./NavTab.vue?vue&type=style&index=0&id=36bfdd1c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-36bfdd1c"

export default script